import script from "./deliOnceImg2.vue?vue&type=script&setup=true&lang=js"
export * from "./deliOnceImg2.vue?vue&type=script&setup=true&lang=js"

import "./deliOnceImg2.vue?vue&type=style&index=0&id=6cb23c84&lang=less"

const __exports__ = script;

export default __exports__